




import ShipmentCertificate from "./ShipmentCertificate.vue";
import ShipmentCertificateMobile from "../mobile/shipment/ShipmentCertificateMobile.vue";
import ResponsiveLayout from "../../mixin/ResponsiveLayout.vue";

export default {
  components: {
    ResponsiveLayout,
    ShipmentCertificate,
    ShipmentCertificateMobile,
  },
  data() {
    return {
      ShipmentCertificateMobile,
      ShipmentCertificate,
    };
  },
};
